import { render } from "./comissionFees.vue?vue&type=template&id=0c384cfe&scoped=true"
import script from "./comissionFees.vue?vue&type=script&lang=js"
export * from "./comissionFees.vue?vue&type=script&lang=js"

import "./comissionFees.vue?vue&type=style&index=0&id=0c384cfe&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c384cfe"]])

export default __exports__